<template>
  <div class="container">
    <scroll @pulldown="refresh">
        <section class="address_box">
            <section class="company">
                <img src="@/assets/images/themes/icon_location_0.png" alt="">
                <p>{{common.userTenantInfo.company}}</p>
            </section>
            <p class="time">{{newDate}}</p>
        </section>
        <!-- nav数据 -->
        <section class="mess_nav">
            <section class="nav_item">
                <p class="nav_item_top best">优</p>
                <img class="loop_img" src="@/assets/images/icon_loop.png">
                <p class="nav_item_bottom">环境指数</p>
            </section>
            <section class="nav_item">
                <p class="nav_item_top nav_item_top_l">{{(common.teamReport.normal||0)+(common.teamReport.late||0)}}<span>/{{(common.teamReport.normal||0)+(common.teamReport.late||0)+(common.teamReport.unNormal||0)}}</span></p>
                <p class="nav_item_bottom">员工人员统计</p>
            </section>
            <section class="nav_item">
                <p class="nav_item_top">{{common.visitedNum}}</p>
                <p class="nav_item_bottom">访客来访</p>
            </section>
            <section class="nav_item">
                <p class="nav_item_top">{{common.meetingUseTime}}</p>
                <p class="nav_item_bottom">会议室使用</p>
            </section>
        </section>
        <!-- module -->
        <section class="module_box">
            <h2>智慧服务</h2>
            <section class="module_list">
                <section class="module_item" v-for="item in moduleList" :key="item.title" @click="toModule(item)">
                    <img :src="item.img">
                    <span>{{item.title}}</span>
                </section>
            </section>
        </section>
    </scroll>
    <nav-bar :tab="2"></nav-bar>
  </div>
</template>

<script>
import NavBar from "@/components/navbar";
import Scroll from "@/components/scroll";
import util from "@/utils/util";
import {mapState, mapActions} from 'vuex';
import * as api from "@/utils/api";
export default {
    data(){
        return {
            newDate:'',
            moduleList:[
                {img:require('../../../assets/images/icon_smart_report.png'),title:'奋斗报告',url:"/smartOffice/StruggleReport"},
                {img:require('../../../assets/images/icon_smart_meeting.png'),title:'会议预订',url:"/smartOffice/meetingRoom"},
                {img:require('../../../assets/images/icon_smart_enviroment.png'),title:'环境指数',url:"/smartOffice/environmental"},
                {img:require('../../../assets/images/icon_smart_printer.png'),title:'云打印',url:""},
                {img:require('../../../assets/images/icon_smart_controller.png'),title:'智慧终端',url:""},
                {img:require('../../../assets/images/icon_smart_energy.png'),title:'能耗曲线',url:"/smartOffice/energyConsumption"},
            ]
        }
    },
    components:{
        NavBar,
        Scroll
    },
    computed: {
        ...mapState({
        common: state => state.common
        })
    },
    created(){
        this.newDate = util.formatTime(new Date(),25)
        if(Object.keys(this.common.teamReport).length<=0){
            this.getteamReportAction();
            this.getMeetingOrderListSmart();
        }
    },
    methods:{
        ...mapActions(['getmeetingUseTime','getTeamReport']),
        refresh(){
            this.newDate = util.formatTime(new Date(),25)
            this.getMeetingOrderListSmart();
            this.getteamReportAction();
        },
        toModule(item){
            if(item.url){
                if(item.url == '/smartOffice/StruggleReport'){
                    if(this.common.userTenantInfo.roleId == '1' || this.common.userTenantInfo.roleId == '2'){
                        this.$router.push(item.url)
                    }else{
                        this.$router.push('/smartOffice/StruggleCalendar')
                    }
                }else{
                    this.$router.push(item.url)
                }
            }else{
                util.showToast("敬请期待~")
            }
        },
        getMeetingOrderListSmart(){
            util.showLoading()
            var param = {
                userId: '',
                beginTime:util.formatTime(new Date(),4),
                endTime:util.formatTime(new Date(),4),
                pageNo: 1,
                pageSize: 1000
            }
            api.getMeetingOrderListSmart(param).then(res => {
                console.log(res)
                util.hideLoading();
                if(res.res && res.res.code === 10000 && res.body){
                    this.getmeetingUseTime(res.body.count || 0);
                }
            });
        },
        getteamReportAction(){
            let params = {
                companyId:this.common.userTenantInfo.companyId,
                orgId:'',
                queryDate:util.formatTime(new Date(),4),
            }
            api.teamReport(params).then(res => {
                if (res.res && res.res.code === 10000 && res.body) {
                    console.log(res)
                    this.getTeamReport(res.body || {})
                }
            });
        },
    }
}
</script>

<style lang="less" scoped>
@import "../../../assets/css/common.less";
.container{
    height:100vh;
    background:#eee;
}
.address_box{
    margin-left:28px;
    .company{
        margin-top:20px;
        margin-bottom: 10px;
        .flex();
        align-items: center;
        img{
            display:block;
            width:36px;
            height:36px;
            margin-right:8px;
            flex-shrink: 0;
        }
        p{
            flex:1;
            font-size:36px;
            font-weight:bold;
            color:rgba(24,24,24,1);
            line-height:50px;
        }
    }
    .time{
        font-size:28px;
        color:rgba(94,119,140,1);
        line-height:40px;
        margin-bottom:28px;
        margin-left:44px;
    }
}
.mess_nav{
    margin:0 20px 20px 20px;
    .flex();
    height:262px;
    border-radius:16px;
    background:url('../../../assets/images/img_smart_home_bg.jpg') left center no-repeat;
    background-size:100% 100%;
    .nav_item{
        .flex(column);
        align-items: center;
        justify-content: flex-end;
        flex:1;
        position: relative;
        .nav_item_bottom{
            font-size:24px;
            color:rgba(255,255,255,1);
            line-height:34px;
            margin-top:22px;
            margin-bottom:80px;
        }
        .nav_item_top{
            font-size:52px;
            color:rgba(255,255,255,1);
            line-height:48px;
            font-family:'DIN-Medium';
            span{
                font-size:28px;
                font-weight: normal;
            }
        }
        .nav_item_top_l{
            margin-bottom:-8px;
        }
        .best{
            font-size:52px;
            color:#5FF85E;
        }
        .loop_img{
            position:absolute;
            width:88px;
            height:88px;
            bottom:116px;
            animation: rotate linear 3s infinite;
        }
    }
}
.module_box{
    margin:0 20px 20px 20px;
    background:rgba(255,255,255,1);
    border-radius:16px;
    h2{
        height:100px;
        font-size:28px;
        color:rgba(102,102,102,1);
        line-height:100px;
        padding-left:28px;
    }
    .module_list{
        .flex();
        .module_item{
            width:33.33%;
            box-sizing:border-box;
            border:1px solid rgba(240,240,240,1);
            border-left:0;border-bottom:0;
            .flex(column);
            align-items:center;
            justify-content: center;
            height:236px;
            img{
                width:128px;
                height:128px;
                margin-bottom:4px;
            }
            span{
                font-size:28px;
                color:rgba(51,51,51,1);
                line-height:40px;
            }
        }
    }
}
@keyframes rotate {
    0 {
        transform:rotate(0deg);
        opacity:1;
    }
    50%{
        transform:rotate(180deg);
        opacity:0.2;
    }
    100%{
        transform:rotate(360deg);
        opacity:1;
    }
}
</style>